import {IDataSourceAdapter} from '~/lib/dataSource';
import {ID} from '~/lib/model';
import {createUser, createUserPermission, deleteUserPermission, fetchUser, fetchUsers, updateUser} from '~/modules/Users/api';
import {IUser} from '~/modules/Users/models/User';
import {IUserPermission} from '~/modules/Users/models/UserPermission';


export const usersAdapter: IDataSourceAdapter<IUser> = {
    fetchRecords: fetchUsers,
    updateRecord: updateUser,
    createRecord: createUser
};

export const userPermissionsAdapter: IDataSourceAdapter<IUserPermission> = {
    fetchRecords: (userId: ID) => fetchUser(userId).then(user => user.permissions),
    createRecord: createUserPermission,
    deleteRecord: deleteUserPermission
};
